export const removeSpecialCharacterFromSearchQuery = (
  query: string
): string => {
  const regex = /[+=&|><!(){}[\]^"~*?:\\/]/g;

  return query.replace(regex, '').trim();
};
